import React from 'react';
import DraftItemListBatchActions from './DraftItemListBatchActions';
import DraftItemListBatchActionsService from '../services/DraftItemListBatchActionsService';
import DraftItemListService from '../services/DraftItemListService';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

const DraftItemListBatchActionsContainer = () => (
  <DraftItemListBatchActions
    submitting={DraftItemListBatchActionsService.submit.fetching}
    enablePublishSelectedItems={DraftItemListService.selectedItems.length > 0}
    onPublishSelectedDrafts={DraftItemListBatchActionsService.handlePublishSelectedDrafts}
    onPublishEntireUnit={DraftItemListBatchActionsService.handlePublishEntireUnit}
    enablePublishEntireUnit={toJS(DraftItemListService.enablePublishEntireUnit)}
    onPublishEntireMasteryTest={DraftItemListBatchActionsService.handlePublishEntireMasteryTest}
    enablePublishEntireMastery={toJS(DraftItemListService.enablePublishEntireMastery)}
  />
);

export default observer(DraftItemListBatchActionsContainer);
